module.exports = __webpack_public_path__ + "img/andrew-jackson.1cf62c38.png";